import {useEffect, useRef, useState} from 'react'
import {workspaceApi} from './workspaceApi.js'
import {verifyOriginal} from './originalVerification.js'

export default function VerifiedOriginal({item}) {
  const [state, setState] = useState({busy: false, error: '', verified: null, url: null})
  const active = useRef(true), locked = useRef(false), url = useRef(null)
  useEffect(() => {active.current = true; return () => {active.current = false; if (url.current) URL.revokeObjectURL(url.current)}}, [])
  const verify = async () => {
    if (locked.current) return
    locked.current = true
    setState({busy: true, error: '', verified: null, url: null})
    try {
      const blob = await workspaceApi.asset(item.jobId, item.assetId)
      const verified = await verifyOriginal(blob, item.originalSha256)
      if (!active.current) return
      if (url.current) URL.revokeObjectURL(url.current)
      url.current = URL.createObjectURL(blob)
      setState({busy: false, error: '', verified, url: url.current})
    } catch (error) {if (active.current) setState({busy: false, error: error.message, verified: null, url: null})}
    finally {locked.current = false}
  }
  return <div>
    <button className="btn" disabled={state.busy} onClick={verify}>{state.busy ? 'Verifying original bytes…' : 'Verify saved original'}</button>
    {state.error && <p role="alert">{state.error}</p>}
    {state.verified && <><p role="status">Saved and byte-verified: {state.verified.bytes} bytes. Internal review remains separate.</p><a className="btn" href={state.url} download={`artwork-${item.jobId}-${item.assetId}`}>Download verified original</a><details><summary>Preview verified original</summary><img src={state.url} alt={`Saved artwork for ${item.title}`} style={{maxWidth: '100%', height: 'auto'}}/></details></>}
  </div>
}
